import { ActionTypes } from "./types";

const {
  OPEN_DISPENSER_USER_SNACK,
  CLOSE_DISPENSER_USER_SNACK,
  CREATE_DISPENSER_USER,
  CLEAR_DISPENSER_USER,
  GET_DRIVER_USER,
  GET_DISPENSER_USER,
  SET_DISPENSER_USER_FILTERS,
  DISPENSER_USER_SELECTED,
  RESET_DISPENSER_USER_SELECTED,
  
  SET_CONFIG_PAGE_DISPENSER_USER,
  SET_CONFIG_PAGE_SIZE_DISPENSER_USER,
  SET_CONFIG_FILTER_DISPENSER_USER,
  SET_CONFIG_SORTED_DISPENSER_USER
} = ActionTypes;

const INITIAL_STATE = {
  dispenserUser: [],
  station: null,
  unit: null,
  unitOptions: [],
  dispenserUserSelected: {},
  snackBar: { 
    msg: "", 
    isOpen: false 
  },
  config: {
    page: 0,
    pageSize: 20,
    filtered: [],
    sorted: []
  },
};

export const dispenserUserReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {

    case OPEN_DISPENSER_USER_SNACK:
      return {
        ...state,
        snackBar: { 
          msg: payload, 
          isOpen: true 
        }
      };

    case CLOSE_DISPENSER_USER_SNACK:
      return {
        ...state,
        snackBar: { 
          msg: '', 
          isOpen: false 
        }
      };

    case DISPENSER_USER_SELECTED:
      const index = state.dispenserUser.findIndex(item => item.id === payload);
      if (index === -1) return state;
      else return {
        ...state,
        dispenserUserSelected: state.dispenserUser[index]
      };

    case RESET_DISPENSER_USER_SELECTED:
      return {
        ...state,
        dispenserUserSelected: {},
        addMode: false,
        deleteMode: false,
      };

    case CLEAR_DISPENSER_USER:
      return {
        ...state,
        ...INITIAL_STATE,
      };

    case SET_DISPENSER_USER_FILTERS:
      if(payload.key === 'station') return {
        ...state,
        [payload.key]: payload.data,
        dispenserUser: [],
        unit: null
      };

      if(payload.key === 'unit' && payload.data?.id !== state.unit?.id) return {
        ...state,
        [payload.key]: payload.data,
        dispenserUser: []
      };

      return {
        ...state,
        [payload.key]: payload.data
      };

    case GET_DISPENSER_USER:
      return {
        ...state,
        dispenserUser: payload
      };

    case GET_DRIVER_USER:
      return {
        ...state,
        unit: {
          ...state.unit,
          driverUser: payload
        }
      };

    case CREATE_DISPENSER_USER:
      const indx = state.dispenserUser.findIndex(item => item.id === payload.idDispenser);
      if (indx === -1) return state;
      const { imei } = payload;
      const editedUser = state.dispenserUser;
      editedUser[indx] = {
        ...editedUser[indx],
        dispenserUser: {
            ...payload,
            imei: imei ? imei : 'SIN ASIGNAR'
        }
      };
      return {
        ...state,
        dispenserUser: editedUser
      };

    case SET_CONFIG_FILTER_DISPENSER_USER:
      return {
        ...state,
        config: {
          ...state.config,
          filtered: payload,
          page: 0,
        },
      };

    case SET_CONFIG_PAGE_DISPENSER_USER:
      return {
        ...state,
        config: {
          ...state.config,
          page: payload,
        },
      };

    case SET_CONFIG_PAGE_SIZE_DISPENSER_USER:
      return {
        ...state,
        config: {
          ...state.config,
          pageSize: payload,
          page: 0,
        },
      };

    case SET_CONFIG_SORTED_DISPENSER_USER:
      return {
        ...state,
        config: {
          ...state.config,
          sorted: payload,
          page: 0,
        }
      };

    default:
      return state;
  }
};